import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import "./style.scss";
import { GrClose } from "react-icons/gr";
import "../../style/block.scss";
import "../../style/buttons.scss";
import { Assort } from "../../app/models/Assort";
import { t } from "i18next";
import { TicketAccess } from "../../app/models/TicketAccess";
import TicketLineSummary from "../../app/components/Universal/TicketLineSummary";
import PreBasketSummary from "../../app/components/Universal/PreBasketSummary";
import usePreBasket from "../../app/components/Universal/hooks/usePreBasket";
import useBasketManager from "../../app/components/SaleMovie/CinemaHall/hooks/useBasketManager";
import { BasketItem } from "../../app/models/BasketItem";
import { Exercise } from "../../app/models/Exercise";
import LoadableComponent from "../Loading/LoadableComponent";
import useCalculatePreBasketQnt from "../../app/components/Universal/hooks/useCalculatePreBasketQnt";

interface IProps {
  footer: boolean;
  open: boolean;
  afterOpenModal?: () => void;
  closeModal: () => void;
  styles?: any;
  children: any;
  title: string;
  leftType?: string;
  leftImage?: string;
  leftTitle?: string;
  leftText?: string;
  acceptText?: string;
  cancelText?: string;
  ticketLists?: Assort[];
  exercise?: Exercise;
  onAccept: () => void;
  ticketAccess?: TicketAccess;
  loading?: boolean;
}

// const customStyles = {
//   content: {
//     top: "50%",
//     left: "50%",
//     right: "auto",
//     bottom: "auto",
//     marginRight: "-50%",
//     transform: "translate(-40%, -50%)",
//     backgroundColor: "var(--dark-background)",
//     borderRadius: "12px",
//     width: "60%",
//   },
// };

// const customStylesMobile = {
//   content: {
//     top: "50%",
//     left: "50%",
//     right: "auto",
//     bottom: "auto",
//     marginRight: "-50%",
//     transform: "translate(-50%, -50%)",
//     backgroundColor: "var(--dark-background)",
//     borderRadius: "12px",
//     width: "80%",
//   },
// };

const ModalComponent: React.FC<IProps> = ({
  footer,
  open,
  afterOpenModal = () => {},
  closeModal,
  styles,
  children,
  title,
  leftType,
  leftTitle,
  leftText,
  leftImage,
  ticketLists,
  acceptText = t("akceptuj"),
  cancelText = t("anuluj"),
  ticketAccess,
  onAccept,
  exercise,
  loading = false,
}: IProps) => {
  const { getBasket } = useBasketManager();
  const { preBasket, addItemToBasket, removeItemFromBasket, clearBasket } = usePreBasket();
  const [limit, setLimit] = useState(0);
  const { qntState } = useCalculatePreBasketQnt(preBasket);
  const handleDeleteBasket = () => {
    clearBasket();

    setTimeout(() => {
      getBasket();
    }, 200);
  };

  useEffect(() => {
    if (exercise) {
      setLimit(exercise.capacity - (exercise.prereservation + exercise.reserved));
    }
  }, [exercise]);

  const ticketsInCurrentBasket = () => preBasket.reduce((acc: number, item: BasketItem) => acc + item.qnt, 0);

  return (
    <Modal
      id="modal-1"
      isOpen={open}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      contentLabel="modal"
      className="modal-container shadow"
    >
      <LoadableComponent loading={loading}>
        {leftImage && (
          <React.Fragment>
            {leftType === "exercise" && (
              <div className="left-modal">
                <div className="exercise-picture" style={{ backgroundImage: `url(${leftImage})` }}>
                  <b>{leftTitle}</b>
                </div>
              </div>
            )}
          </React.Fragment>
        )}

        {leftType === "pass" && (
          <div className="left-modal ">
            <div className="pass-type">
              <span>{t("szczegoly_karnetu")}</span>
              {leftImage && <div className="exercise-picture" style={{ backgroundImage: `url(${leftImage})` }}></div>}
              <b className="pass-type-title">{leftTitle}</b>
              {leftText && (
                <article className="text-description" dangerouslySetInnerHTML={{ __html: leftText }}></article>
              )}
            </div>
          </div>
        )}

        {leftType === "news" && (
          <div className="left-modal ">
            <div className="pass-type">
              <div className="exercise-picture" style={{ backgroundImage: `url(${leftImage})` }}></div>
            </div>
          </div>
        )}

        <div
          className={
            leftType === "pass" || leftType === "exercise" || leftType === "news"
              ? "right-modal border-right"
              : "full-right-modal right-modal "
          }
        >
          <div className="title">
            <h2>{title}</h2>
            <button onClick={closeModal}>
              <GrClose className="icon" />
            </button>
          </div>
          <div className="content-right">{children}</div>

          {footer && (
            <div className="flex-end-center footer">
              <button className="button medium padding-medium button-outline-main" onClick={closeModal}>
                {cancelText}
              </button>
              <button className="button medium padding-medium button-fill-main" onClick={onAccept}>
                {acceptText}
              </button>
            </div>
          )}
        </div>
        {ticketLists && exercise && (
          <div className="tickets">
            <div className={"calendar-sale-ticket"}>
              {ticketLists.map((itemTicket, index) => (
                <div className={"ticket-block"} key={index}>
                  {/* <TicketLine item={itemTicket} exercise={ticketAccess} /> */}
                  <TicketLineSummary
                    item={itemTicket}
                    exercise={ticketAccess}
                    preBasket={preBasket}
                    addItemToBasket={addItemToBasket}
                    removeItemFromBasket={removeItemFromBasket}
                    ticketLimit={limit}
                    qntState={qntState}
                  />
                </div>
              ))}

              {limit === ticketsInCurrentBasket() && (
                <div className="flex-between-center alert alert-red ">
                  <b>{t("nie_mozesz_dodac_wiekszej_ilosci_biletow_do_koszyka")}</b>
                </div>
              )}
              <PreBasketSummary ticketLimit={limit} preBasket={preBasket} clearBasket={handleDeleteBasket} />
              {/* <TicketLine item={item} exercise={ticketAccess} /> */}
            </div>
          </div>
        )}
      </LoadableComponent>
    </Modal>
  );
};
Modal.setAppElement("#root");

export default ModalComponent;
